var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid px-0"},[_c('div',{staticClass:"row-fluid bg-blue py-2 justify-content-center"},[_c('b-img',{staticClass:"logo mb-0",attrs:{"alt":"teddi-logo","src":require('@/assets/logo/teddi-white.svg')}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }